import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'sales',
    permissionsPrefix: 'sales',
    displayName: 'Sales',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/sales/dashboard' },
        { key: 'orders', label: 'Orders', route: '/sales/orders' },
        { key: 'toInvoice', label: 'To Invoice', route: '/sales/to-invoice' },
        { key: 'products', label: 'Products', route: '/sales/products' },
        { key: 'reporting', label: 'Reporting', route: '/sales/reporting' },
        { key: 'configuration', label: 'Configuration', route: '/sales/configuration' },
    ],

    resources: [
        { key: 'quotations', label: 'Quotations', navSection: 'orders' },
        { key: 'saleOrders', label: 'Sales orders', navSection: 'orders' },
        { key: 'deliveryOrders', label: 'Delivery orders', navSection: 'orders' },
        // 1.8-3: the post-approval warehouse/dispatch chain is a distinct right — plain
        // deliveryOrders.write no longer moves an approved DO through the warehouse.
        { key: 'deliveryOrderDispatch', label: 'Delivery orders — warehouse & dispatch', navSection: 'orders' },
        { key: 'customers', label: 'Customers', navSection: 'orders' },
        { key: 'products', label: 'Products', navSection: 'products' },
        { key: 'pricelists', label: 'Pricelists', navSection: 'configuration' },
        { key: 'paymentTerms', label: 'Payment terms', navSection: 'configuration' },
        { key: 'salesReports', label: 'Sales reports', navSection: 'reporting' },
    ],
} satisfies WorkspaceAppManifest;
